<template lang="pug" src="./custom-team.pug"></template>

<script>
import Icon from 'components/icon/icon'
import TeamModal from 'components/modal/team/modal-team'

export default {
  props: ['content'],
  data: () => {
    return {
      showModal: false
    }
  },
  components: {
    Icon,
    TeamModal
  }
}
</script>



// WEBPACK FOOTER //
// custom-team.vue?a170573c